import { View, Map, Overlay, Feature } from 'ol';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import { XYZ, OSM, Source } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import { FitOptions } from 'ol/View';
import { ScaleLine } from 'ol/control';
import { koCenter, koExt } from './util';
import { Select, Translate, defaults as defaultInteractions } from 'ol/interaction';
import WebGLTileLayer from 'ol/layer/WebGLTile.js';
import ImageTileSource from 'ol/source/TileImage';
import { sourcesFromTileGrid } from 'ol/source.js';
import { Point } from 'ol/geom';
import Style from 'ol/style/Style';
import { Circle, Fill } from 'ol/style.js';
import { always, pointerMove } from 'ol/events/condition';

// import Source from 'ol/source/ImageTile.js';

//코어를 담당하는 mapInstance Viewer객체
//Viewr객체의 기능
class OlAddress {
  public osmMapSource = new OSM();
  private markerLayer: VectorLayer<VectorSource> = new VectorLayer<VectorSource>();
  private markerSource: VectorSource;
  private markerFeature!: Feature;

  // 기본 2D 지도
  public osmMapLayer = new TileLayer({
    source: this.osmMapSource,
    properties: { name: 'osm-map' },
    zIndex: 1,
    preload: Infinity,
  });

  public mapInstance: Map;
  public viewer: View;
  public localTileLayer: any;

  //지도 초기화
  constructor() {
    this.mapInstance = new Map({
      target: 'mapAddrContainer',
      layers: [
        this.osmMapLayer,

        // this.PyramidMapLayer,
      ],
      view: new View({
        center: [128, 36],
        // extent: koExt,
        zoom: 6,
        // maxZoom: 20,
        projection: 'EPSG:4326',
      }),
    });

    this.viewer = this.mapInstance.getView();
    // this.mapInstance.addControl(
    //   new ScaleLine({
    //     target: document.getElementById('scaleBar') as any,
    //   }),
    // );

    let center = [128, 36];
    this.markerFeature = new Feature({
      geometry: new Point(center),
    });
    this.markerSource = new VectorSource({
      features: [this.markerFeature],
    });
    this.markerLayer = new VectorLayer({
      zIndex: 10,
      style: new Style({
        image: new Circle({
          radius: 5,
          fill: new Fill({ color: 'red' }),
        }),
      }),
      source: this.markerSource,
    });

    this.mapInstance.addLayer(this.markerLayer);
  }

  public getMapInstance() {
    return this.mapInstance;
  }

  public clickMap(setState) {
    this.mapInstance.on('click', (e) => {
      setState(e.coordinate);
      this.markerLayer.getSource()?.getFeatures()[0].setGeometry(new Point(e.coordinate));
      this.mapInstance.getView().fit(new Point(e.coordinate), { duration: 500, maxZoom: 17 });
    });
    // this.mapInstance.on('pointerdrag', (e) => {
    //   console.log(e);
    // });
  }
  public setMarker(coord) {
    this.markerLayer.getSource()?.getFeatures()[0].setGeometry(new Point(coord));
    this.mapInstance.getView().fit(new Point(coord), { duration: 500, maxZoom: 17 });
  }
}

export default OlAddress;
